// Return existing element(s)
function getElement(id) {
    return document.getElementById(id);
}

function getSelector(selector) {
    return document.querySelector(selector);
}

function getAllElements(selector) {
    return document.querySelectorAll(selector);
}

// Sets element attribute
function setElementAttribute(id, attribute, value) {
    const element = getElement(id);
    if (element) {
        element[attribute] = value;
    }
}

function setAttrByArray(element, attrArray) {
    for (let { attr, value } of attrArray) {
        element.setAttribute(attr, value);
    }
}

// Show/hide spinner to give container time to load
function toggleSpinnerAndContainer(spinnerId, containerId, delay) {
    const spinner = document.getElementById(spinnerId);
    const container = document.getElementById(containerId);

    if ( spinner ) {
        spinner.classList.add('visible-container');
        spinner.style.display = 'block';
    }

    if ( spinner && container ) {
        setTimeout(() => {
            spinner.classList.remove('visible-container');
            spinner.style.display = 'none';
            container.classList.add('visible-container');
            container.classList.remove('hidden-container');
        }, delay);
    }
}

export { 
    getElement,
    getSelector,
    getAllElements,
    setElementAttribute, 
    setAttrByArray,
    toggleSpinnerAndContainer
};